var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompareIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.94,14.658l-3.005-8.265c-.461-1.267-1.519-2.21-2.829-2.523l-5.105-1.221V1c-.006-1.308-1.994-1.307-2,0v1.17L6.531,1.102c-1.514-.404-3.061,.404-3.59,1.869L.063,10.649c-.042,.112-.063,.653-.063,.653,0,2.506,1.871,4.567,4.26,4.692,1.251,.063,2.434-.372,3.338-1.229,.891-.846,1.402-2.036,1.402-3.264,0,0-.022-.745-.067-.859L6.006,3.032c.012,.002,4.994,1.194,4.994,1.194V22H5c-1.308,.006-1.307,1.994,0,2h14c1.308-.006,1.307-1.994,0-2h-6V4.705l4.641,1.11c.198,.047,.384,.124,.554,.224l-3.135,8.619c-.04,.109-.06,.644-.06,.644-.078,3.923,4.749,6.268,7.597,3.462,.892-.846,1.403-2.036,1.403-3.264,0,0,0-.538-.06-.842ZM6.544,10H2.443l2.024-5.401,2.078,5.401Zm12.956-1.699l2.072,5.699h-4.145l2.072-5.699Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompareIcon);
export default __webpack_public_path__ + "static/media/compareIcon.2149cd5ef5d7b33036d6ce893e35083e.svg";
export { ForwardRef as ReactComponent };